import Vue from 'vue';
import newFaqs from '@/content/newFaqs';
export default Vue.extend({
    computed: {
        faq() {
            var _a, _b, _c, _d;
            return ((_d = (_c = (_b = (_a = newFaqs[0].children) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.items) || [];
        },
    },
});
